import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { uString } from '@hidat/huijs-common';
import { ShowAndSegmentNamerController } from '@splixer/player-ui';

@Component({
  selector: 'kexp-mix-and-segment',
  templateUrl: 'mix-and-segment.component.html',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KexpMixAndSegmentComponent extends ShowAndSegmentNamerController {
  /**
   * Checks to see if this mix is host based, and if it is, rounds the image
   * 12/12/2025 - Removing for now as getting the rest of the system to dynamically do this is 'involved'
   * @protected
   */
  protected imageKlasses = computed(() => {
    let name: uString;
    const ts = this.item();
    if (ts?.mix) {
      console.debug(ts.mix.sourceType)
      if (ts.mix.sourceType === 'Host') {
        return 'rounded-full'
      }
    }
    return undefined;
  });

  protected showName = computed(() => {
    let name: uString;
    const ts = this.item();
    if (ts) {
      name = this.showNameFromTimeline(ts);
      const mn = this.mixNameFromTimeline(ts);
      if (name && mn && name === mn) {
        name = undefined;
      }
    }
    return name;
  });
}
